import { Reducer } from 'redux';
import { IDeclarationStatus, IDeclarationStatusActionTypes } from './Types';

const initialDeclarationStatus: IDeclarationStatus = {
  response: null,
  isLoading: false,
  error: '',
};

const reducer: Reducer<IDeclarationStatus> = (
  state = initialDeclarationStatus,
  action
) => {
  switch (action.type) {
    case IDeclarationStatusActionTypes.GET_DECLARATION_STATUS: {
      return {
        ...state,
        isLoading: true,
        error: '',
        response: null,
      };
    }
    case IDeclarationStatusActionTypes.GET_DECLARATION_STATUS_FAILURE: {
      return {
        ...state,
        isLoading: false,
        error: action.payload,
        response: null,
      };
    }
    case IDeclarationStatusActionTypes.GET_DECLARATION_STATUS_SUCCESS: {
      return {
        ...state,
        isLoading: false,
        error: '',
        response: action.payload,
      };
    }
    default: {
      return state;
    }
  }
};

export { reducer as DeclarationStatusReducer };
